import {
  CarHireItemType,
  ExperienceItemType,
  FlightItemType,
  HotelItemType,
} from '@reward-platform/order-schemas/common'
import {
  createSelectedPaymentOptionsSchema,
  SelectedPaymentOptions,
} from '@reward-platform/order-schemas/form-data'
import { StorageKeys, useStateStorage } from '@reward-platform/utils'
import useBasket from '~/hooks/useBasket/useBasket'

const usePaymentOptions = (allowItemWithoutPaymentOption = false) => {
  const {
    basket: { data: basket },
  } = useBasket()

  return useStateStorage<SelectedPaymentOptions | undefined>({
    key: StorageKeys.BASKET_PAYMENT_OPTIONS,
    parser: (value) => {
      if (!basket) {
        return undefined
      }

      const hotelBasketItem = basket.items[HotelItemType]?.[0]
      const carHireBasketItem = basket.items[CarHireItemType]?.[0]
      const experienceBasketItem = basket.items[ExperienceItemType]?.[0]
      const flightBasketItem = basket.items[FlightItemType]?.[0]

      const schema = createSelectedPaymentOptionsSchema({
        hotelBasketItem,
        carHireBasketItem,
        experienceBasketItem,
        flightBasketItem,
        allowItemWithoutPaymentOption,
      })

      const res = schema.safeParse(value)
      return res.success ? res.data : undefined
    },
  })
}

export default usePaymentOptions
